export enum VotingResultType {
    none = "none",
    accepted = "accepted",
    denied = "denied"
}
